var _defs, _path, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 202.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #217dfb;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    className: "cls-1",
    d: "M251.16,54.95L61.44,0s-11.1,27.55-38.31,25.24L0,105.24s27.36,7.53,18.61,42.58l189.72,54.95c11.39-34.28,38.51-26.03,38.51-26.03l23.17-80c-24.21-12.57-18.86-41.8-18.86-41.8h.01Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    className: "cls-2",
    d: "M138.89,131.75l-75.04-21.79c-1.58-.42-2.52-2.04-2.09-3.62.01-.04.02-.07.03-.11l14.69-50.69c.42-1.58,2.05-2.52,3.62-2.09.04,0,.07.02.1.03l75.04,21.76c1.58.42,2.52,2.04,2.09,3.62-.01.04-.02.07-.03.11l-14.69,50.69c-.49,1.58-2.14,2.49-3.74,2.06v.03ZM68.46,105l69.2,20.08,13.01-44.84-69.25-20.04-12.97,44.84v-.05Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    className: "cls-2",
    x: 208.46,
    y: 44.81,
    width: 12.97,
    height: 12.97,
    transform: "translate(105.96 243.52) rotate(-73.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    className: "cls-2",
    x: 201.54,
    y: 68.65,
    width: 12.97,
    height: 12.97,
    transform: "translate(78.05 254.09) rotate(-73.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    className: "cls-2",
    x: 194.64,
    y: 92.54,
    width: 12.97,
    height: 12.97,
    transform: "translate(50.13 264.72) rotate(-73.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    className: "cls-2",
    x: 187.7,
    y: 116.38,
    width: 12.97,
    height: 12.97,
    transform: "translate(22.21 275.27) rotate(-73.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    className: "cls-2",
    x: 180.76,
    y: 140.28,
    width: 12.97,
    height: 12.97,
    transform: "translate(-5.76 285.86) rotate(-73.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    className: "cls-2",
    x: 173.87,
    y: 164.18,
    width: 12.97,
    height: 12.97,
    transform: "translate(-33.69 296.5) rotate(-73.87)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsEntry);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons_Entry.60e97b104f37c6a9085228a2589851b5.svg";
export { ForwardRef as ReactComponent };